import { Grid, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CGraphTotalCommittedCapital from '../../components/dashboard/CGraphTotalCommittedCapital';
import CGlobalNetIRR from '../../components/dashboard/CGlobalNetIRR';
import CTypeInvestmentItem from '../../components/dashboard/CTypeInvestmentItem';
import IDashboardFundType from '../../interfaces/dashboard/IDashboardFundType';
import useInvestDashboardKpis from '../../hooks/dashboard/useInvestDashboardKpis';
import CTvpi from '../../components/dashboard/CTvpi';
import VNewsArticleLastDashboard from '../../../news/views/VNewsArticleLastDashboard';

const VInvestDashboard = () => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	const { globalKpis, fundTypes } = useInvestDashboardKpis();

	const [globalNetIRR, setGlobalNetIRR] = useState<number>();
	const [globalNetIrrIsNs, setGlobalNetIrrIsNs] = useState<boolean>();

	const [totalValueToPaidIn, setTotalValueToPaidIn] = useState<number>();
	const [totalValueToPaidInIsNs, setTotalValueToPaidInIsNs] = useState<boolean>();
	useEffect(() => {
		if (globalKpis) {
			setGlobalNetIRR(globalKpis.globalNetIrr ?? undefined);
			setGlobalNetIrrIsNs(globalKpis.globalNetIrrIsNs);
			setTotalValueToPaidIn(globalKpis.totalValueToPaidIn ?? undefined);
			setTotalValueToPaidInIsNs(globalKpis.totalValueToPaidInIsNs);
		}

		return () => {
			setGlobalNetIRR(undefined);
			setTotalValueToPaidIn(undefined);
		};
	}, [globalKpis]);

	return (
		<Grid container spacing={3} alignItems="stretch">
			<Grid item xs={12} sm={8}>
				<CGraphTotalCommittedCapital fundTypes={fundTypes ?? []} />
			</Grid>
			<Grid container item spacing={3} xs={12} sm={4} alignItems="stretch">
				<Grid item xs={12} style={{ height: '50%' }}>
					<CGlobalNetIRR value={globalNetIRR ?? null} isNS={globalNetIrrIsNs} />
				</Grid>
				<Grid item xs={12} style={{ height: '50%' }}>
					<CTvpi value={totalValueToPaidIn ?? null} isNS={totalValueToPaidInIsNs} />
				</Grid>
			</Grid>
			<Grid item xs={12} sm={12}>
				{!isMobile ? (
					<Grid container spacing={3}>
						{fundTypes &&
							fundTypes.map((fundType: IDashboardFundType, index: number) => {
								return (
									<Grid key={index} item xs={12} sm={4}>
										<CTypeInvestmentItem
											investmentTypeTag={fundType.tag}
											amount={fundType.committedCapital}
											currency={fundType.currency}
										/>
									</Grid>
								);
							})}
					</Grid>
				) : (
					<>
						<div
							style={{
								height: '110px',
								overflowX: 'scroll',
								display: 'flex',
								flexWrap: 'wrap',
								flexDirection: 'column',
							}}
						>
							{fundTypes &&
								fundTypes.map((fundType: IDashboardFundType, index: number) => {
									return (
										<div
											key={index}
											style={{
												width: fundTypes.length > 1 ? '80%' : '100%',
												marginRight: fundTypes.length > 1 ? '30px' : '0px',
											}}
										>
											<CTypeInvestmentItem
												investmentTypeTag={fundType.tag}
												amount={fundType.committedCapital}
												currency={fundType.currency}
											/>
										</div>
									);
								})}
						</div>
					</>
				)}
			</Grid>
			<Grid item xs={12} sm={8}>
				<VNewsArticleLastDashboard size="medium" />
			</Grid>
		</Grid>
	);
};

export default VInvestDashboard;
